import * as React from "react"
import { Link } from "gatsby"
 
const Footer = () => {
  return (
    <footer className="bg-[#20242C] mt-[100px] py-[80px]">
      <div className="container mx-auto">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-4">
            <Link className="header-logo text-5xl text-white" to="/">Designup</Link>
            <p className="mt-6 text-white leading-7">WebサイトやLPネットショップまでホームページを自分で作る人のための情報メディア。おしゃれなテンプレートや無料のデザインツールの使い方などを紹介します。</p>
            <p className="mt-7 text-sm text-white">© 2024 designup.jp</p>
          </div>
          <div className="col-span-8">
            <div className="flex gap-12 justify-end">
              <div>
                <p className="text-lg font-bold text-[#f2f2f2]">Blog</p>
                <ul className="mt-4 flex flex-col space-y-4 text-sm text-[#f2f2f2]">
                <li><Link to="/homepage">ホームページの作り方</Link></li>
                  <li><Link to="/html_css">HTML&CSS 入門ガイド</Link></li>
                  <li><Link to="/figma">初心者のFigma入門</Link></li>
                  <li><Link to="/studio">STUDIO Web制作ガイド</Link></li>
                  <li><Link to="/eccube">EC-CUBE4 ECサイト構築</Link></li>
                </ul>
              </div>
              <div>
                <p className="text-lg font-bold text-[#f2f2f2]">Category</p>
                <ul className="mt-4 flex flex-col space-y-4 text-sm text-[#f2f2f2]">
                  <li><Link to="/coding">コーディング</Link></li>
                  <li><Link to="/tools">デザインツール</Link></li>
                  <li><Link to="/sozai">デザイン素材</Link></li>
                  <li><Link to="/base">BASE</Link></li>
                  <li><Link to="/elementor">Elementor</Link></li>
                  <li><Link to="/wordpress">Wordpress</Link></li>
                  <li><Link to="/shopify">Shopify</Link></li>
                </ul>
              </div>
              <div>
                <p className="text-lg font-bold text-[#f2f2f2]">Shop</p>
                <ul className="mt-4 flex flex-col space-y-4 text-sm text-[#f2f2f2]">
                <li><Link to="/product-web-uikit.html">WEB-UIKIT</Link></li>
                  <li><Link to="/product-lp-uikit.html">LP-UIKIT</Link></li>
                  <li><Link to="/product-bootcube2.html">Bootcube2</Link></li>
                  <li><Link to="/products">テンプレート一覧</Link></li>
                  <li><Link to="/ui">UI</Link></li>
                </ul>
              </div>
              <div>
                <p className="text-lg font-bold text-[#f2f2f2]">Guide</p>
                <ul className="mt-4 flex flex-col space-y-4 text-sm text-[#f2f2f2]">
                  <li><Link to="/guide.html">ご利用ガイド</Link></li>
                  <li><Link to="/contact.html">お問い合わせ</Link></li>
                  <li><Link to="/term.html">ご利用規約</Link></li>
                  <li><Link to="/shop.html">特定商取引法の表記</Link></li>
                  <li><Link to="/privacy.html">プライバシーポリシー</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
 
 export default Footer
 